import { useState, Fragment } from 'react';
import {
  DataGrid,
  Column,
  Editing,
  Lookup,
  HeaderFilter,
  Search,
} from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import {
  CreateAuthorizedDataSource, CreateAuthorizedStore, getAuthorizationTokenAsync
} from '~/helpers/data';
import { EmailClient } from '~/components/email-client/email-client';
import { ExternalMailSystem } from '~/components/external-mail-system/external-mail-system';
import { appConst } from '~/app-const';
export function CSRRoleDistributionList(props) {
  const [viewEmailClient, setViewEmailClient] = useState(false);
  const [emailFormData, setEmailFormData] = useState();

  const emailAddressTypesData = CreateAuthorizedDataSource(
    { loadUrl: `${window.env.apiEndpoint}/api/v1/Members/EmailAddressTypesLookup` },
    null,
    'Value', false,
  );

  const cSRRoleDistributionListData = CreateAuthorizedDataSource(
    {
      loadUrl: `${window.env.apiEndpoint}/api/v1/CSRRoles/GetCSRRoleDistributionLists`,
      insertUrl: `${window.env.apiEndpoint}/api/v1/CSRRoles/PostCSRRoleDistributionList`,
      updateUrl: `${window.env.apiEndpoint}/api/v1/CSRRoles/PutCSRRoleDistributionList`,
      deleteUrl: `${window.env.apiEndpoint}/api/v1/CSRRoles/DeleteCSRRoleDistributionList`,
    },
    {
      load: { roleId: props.roleId },
      insert: { roleId: props.roleId },
      update: { roleId: props.roleId },
    },
    'Id', false,
  );

  return (
    <Fragment>
      <DataGrid
        dataSource={cSRRoleDistributionListData}
        key="Id"
        {...appConst.defaultGridOptions}
        onRowUpdating={
          (e) => {
            e.newData = { ...e.oldData, ...e.newData };
          }
        }
      >
        <HeaderFilter
          visible
        >
          <Search enabled={true}/>
        </HeaderFilter>
        <Editing
          mode="row"
          allowAdding
          allowDeleting
          allowUpdating
        />
        <Column
          dataField="EmailAddressTypeId"
          dataType="number"
          caption="Email Address Type"
        >
          <Lookup
            dataSource={emailAddressTypesData.store()}
            valueExpr="Value"
            displayExpr="Text"
          />
        </Column>
        <Column
          dataField="Name"
          dataType="text"
          caption="Name"
          allowEditing={false} />
        <Column
          dataField="StatusMessage"
          cellRender={
            (data) => {
              const row = data.data;
              return <ExternalMailSystem statusMessage={row.StatusMessage} hasError={row.HasError} entityId={row.Id} entityType="CSRRoleDistributionList" />
            }
          }
        />
        <Column
          type="buttons"
          width={110}
          buttons={[
            {
              name: "delete",
              hint: "Delete COR Role Distribution List",
              icon: 'trash',
            },
            {
            name: "edit",
            hint:"Edit COR Role Distribution List",
            icon: 'edit',
            },
            {
              name: "email",
              hint: "Send Email to Distribution List",
              icon: 'email',
              visible: (e) => {
                return !e.row.isEditing;
              },
              onClick: async (e) => {
                const token = await getAuthorizationTokenAsync();

                const defaultFromEmailDS = CreateAuthorizedStore({ loadUrl: `${window.env.apiEndpoint}/api/v1/DistributionList/GetDefaultFromEmail` }, null, 'Value');
                defaultFromEmailDS.load().then(
                  (data) => {
                    setViewEmailClient(true);
                    setEmailFormData({ email: token.account.username, name: data[0].fromName, to: e.row.data.Name });
                  },
                  (error) => {
                    notify({ message: error.message, shading: true }, 'error');
                  }
                );
              }
            },
          ]}
        />
      </DataGrid>
      <EmailClient visible={viewEmailClient} formData={emailFormData} setViewEmailClient={setViewEmailClient} />
    </Fragment>
  );
}